var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAvatar = function SvgAvatar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 62 71"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M43.558 30.68q-5.046 5.046-12.273 5.046t-12.341-5.113-5.114-12.341T18.944 5.93Q24.058.817 31.284.817q7.228 0 12.342 5.114 5.113 5.114 5.113 12.34 0 7.228-5.181 12.41M59.92 68.727q-1.91 1.91-4.636 1.91h-48q-2.727 0-4.637-1.91Q.74 66.816.74 64.09v-5.728q0-7.5 5.387-12.886t12.886-5.386h2.318q4.773 2.182 9.955 2.182 5.181 0 9.954-2.182h2.318q7.5 0 12.887 5.386 5.386 5.386 5.386 12.886v5.728q0 2.727-1.909 4.636",
    clipRule: "evenodd"
  })));
};
export default SvgAvatar;